<template>
    <!--Sender-->
    <div class="flex flex-row mb-2">
        <div class="flex w-1 relative">
            <div class="w-full absolute" style="padding-top:100%!important;top:50%;margin-top:-50%;">
                <div class="block absolute top-0" style='width:100%;'>
                    <Avatar v-if="review.sender_bank_code" :image="getBankImage(review.sender_bank_code)" class="flex relative m-0 p-1 surface-0" shape="circle" />
                    <Avatar v-else-if="review.sender_payment_system_code" :image="getPaySysImage(review.sender_payment_system_code)" class="flex relative m-0 p-1 surface-0" shape="circle" />
                    <Avatar v-else :image="'/images/svg/pays/card.svg'" class="flex relative m-0 p-1 surface-0" shape="circle" />
                </div>
            </div>
        </div>
        <span class="flex font-semibold text-800 ml-3
            text-md xl:text-2xl lg:text-xl md:text-lg
            pt-1 pb-1 xl:pt-2 xl:pb-2">
            {{ get_format_amount(review.sender_amount, review.sender_currency_code) }}
        </span>
    </div>

    <!--Recipient-->
    <div class="flex flex-row mb-2">
        <div class="flex w-1 relative">
            <div class="w-full absolute" style="padding-top:100%!important;top:50%;margin-top:-50%;">
                <div class="block absolute top-0" style='width:100%;'>
                    <Avatar v-if="review.recipient_bank_code" :image="getBankImage(review.recipient_bank_code)" class="flex relative m-0 p-1 surface-0" shape="circle" />
                    <Avatar v-else-if="review.recipient_payment_system_code" :image="getPaySysImage(review.recipient_payment_system_code)" class="flex relative m-0 p-1 surface-0" shape="circle" />
                    <Avatar v-else :image="'/images/svg/pays/card.svg'" class="flex relative m-0 p-1 surface-0" shape="circle" />
                </div>
            </div>
        </div>
        <span class="flex font-semibold text-800 ml-3
            text-md xl:text-2xl lg:text-xl md:text-lg
            pt-1 pb-1 xl:pt-2 xl:pb-2">
            {{ get_format_amount(review.recipient_amount, review.recipient_currency_code) }}
        </span>
    </div>

    <!--Comment-->
    <div class="flex flex-row">
        <div class="flex w-1 relative">
            <div v-if="review.public && review.photo_url" class="w-full absolute bottom-0" style="padding-top:100%!important">
                <div class="block absolute bottom-0" style='width:100%;'>
                    <Avatar :image="review.photo_url" class="flex relative m-0 p-0" shape="circle" />
                </div>
            </div>
            <div v-else class="w-full absolute bottom-0" style="padding-top:100%!important">
                <div class="block absolute bottom-0" style='width:100%;'>
                    <Avatar :image="(review.feel) ? '/images/svg/happy_smile.svg' : '/images/svg/sad_smile.svg'" class="flex relative m-0 p-1" :class="(review.feel) ? 'bg-green-50' : 'bg-yellow-50'" shape="circle" />
                </div>
            </div>
        </div>
        <div class="flex flex-1 flex-column ml-3 gap-2">
            <div v-if="review.comment" class="flex flex-1 flex-column surface-0 border-round-top-xl border-round-right-xl border-2 border-100
                p-2 xl:p-3 lg:p-3">
                <span class="text-sm font-medium line-height-2">{{review.comment}}</span>
            </div>

            <div v-if="review.tags && review.tags.length>0" class="flex flex-1 align-items-start gap-2">
                <div class="flex flex-wrap gap-1">
                    <Chip v-for="(item, index) in review.tags" :key="index" class="flex m-0 p-1 xl:p-2 lg:p-2 vertical-align-top"
                        :class="(review.feel) ? 'bg-green-50': 'bg-yellow-50'">
                        <i class="pi text-xs" :class="(review.feel) ? 'text-green-600 pi-star-fill': 'text-yellow-700 pi-star-half-fill'"></i>
                        <span class="text-xs font-medium" :class="(review.feel) ? 'text-green-600': 'text-yellow-700'">
                            {{ item }}
                        </span>
                    </Chip>
                </div>
            </div>

            <div v-if="review.social && (review.social.telegram || review.social.whatsapp || review.social.instagram)" 
                class="flex flex-1 align-items-start gap-2">
                <div class="flex flex-wrap gap-1">
                    <!--NAME-->
                    <Chip v-if="review.sender_name" class="m-0 p-2 vertical-align-top surface-0">
                        <i class="pi pi-user text-xs"></i>
                        <span class="text-xs font-medium">{{ review.sender_name }}</span>
                    </Chip>
                    <!--TG-->
                    <Chip v-if="review.social.telegram" @click="toTelegram(review.social.telegram)" class="m-0 p-2 vertical-align-top surface-0 cursor-pointer" style="color:#0088cc">
                        <i class="pi pi-telegram text-xs" ></i>
                        <span class="text-xs font-medium">{{ review.social.telegram }}</span>
                    </Chip>
                    <!--WhatsApp-->
                    <Chip v-if="review.social.whatsapp" @click="toWhatsApp(review.social.whatsapp)" class="m-0 p-2 vertical-align-top surface-0 cursor-pointer" style="color:#25D366">
                        <i class="pi pi-whatsapp text-xs"></i>
                        <span class="text-xs font-medium">{{ review.social.whatsapp }}</span>
                    </Chip>
                    <!--Instagram-->
                    <Chip v-if="review.social.instagram" @click="toInstagram(review.social.instagram)" class="m-0 p-2 vertical-align-top surface-0 cursor-pointer" style="color:#E1306C">
                        <i class="pi pi-instagram text-xs"></i>
                        <span class="text-xs font-medium">{{ review.social.instagram }}</span>
                    </Chip>
                </div>
            </div>
        </div>
    </div>

    <!--Date-->
    <div class="absolute top-0 right-0 mt-2 mr-2">
        <span class="flex text-xs xl:text-sm text-500 text-right">
            {{ formatDate(review.date_created) }}<br>
        </span>
        <div v-if="isUserInGroup('manager') || isUserInGroup('admin')" @click="goToUser(review.user_id)"
            class="flex flex-row mt-1 text-xs text-primary cursor-pointer">
            <span>{{ get_short_id(review.user_id) }}</span>
            <i class="pi pi-external-link ml-1 text-xs"></i>
        </div>
    </div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { BankList, PaymentSystemList } from '@/assets/js/classes/PaymentSystem.js'

export default {
    name: 'AddReview',
    props: ['review', 'bank_list', 'payment_systems'],
    data() {

    },
    methods: {
        get_format_amount(amount, currency){
            return this.helper.format_amount(amount, currency)
        },
        formatDate(value) {
            return this.helper.format_date_short(value, false)
        },
        formateTimer(time) {
            const time_seconds = time / 1000
            let minutes = Math.floor(time_seconds / 60)
            let seconds = Math.floor(time_seconds % 60)
            if(seconds.toString().length==1) seconds = '0'+seconds
            return `${minutes}:${seconds}`
        },
        getPaySysImage(code){
            let paySysObj = new PaymentSystemList()
            paySysObj.items = this.payment_systems
            const paySysCode = paySysObj.GetImage(code)
            return (paySysCode) ? paySysCode : null
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.bank_list
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : null
        },
        isUserInGroup (type) { return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)},
        get_short_id(value){
            return this.helper.get_short_id(value)
        },
        goToUser(id) {
            const go = this.$router.resolve({path: '/admin/user/' + id})
            window.open(go.href, '_blank')
        },
        toTelegram(username) {
            const url = `https://t.me/${username.replace('@','')}`
            window.open(url, '_blank')
        },
        toWhatsApp(number) {
            const url = `https://wa.me/${number.replace('+','')}`
            window.open(url, '_blank')
        },
        toInstagram(username) {
            const url = `https://instagram.com/${username.replace('@','')}`
            window.open(url, '_blank')
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    }
}
</script>   